import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {Cards, useCardsUpdate} from 'Event/template/Cards'
import Settings from 'Event/template/Cards/Leaderboard/LeaderboardConfig/Settings'
import Styling from 'Event/template/Cards/Leaderboard/LeaderboardConfig/Styling'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'

export default function LeaderboardConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props
  const {control, register, handleSubmit, formState, watch} = useForm()
  const updateTemplate = useCardsUpdate()

  const submit = (data: {
    title: string
    description: string
    menuTitle: string
    isVisible: boolean
    points_unit: Cards['points_unit']
    rewardAlert: Cards['rewardAlert']
  }) => {
    const {points_unit, rewardAlert, ...leaderboardData} = data

    updateTemplate({
      leaderboard: leaderboardData,
      points_unit,
      rewardAlert,
    })

    props.onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Leaderboard"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <SettingsPanel>
        <Settings control={control} register={register} watch={watch} />
      </SettingsPanel>
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
